<template>
<div class="chapter">
<div class="inner_page">
<p class="linespace"> </p>
<p class="linespace"> </p>
<p class="linespace"> </p>
<p class="linespace"> </p>
<h2 class="h2"><a id="page_1"></a><a id="frontmatter02"></a>Prologue</h2>
<p class="para">When life gives you lemons, you make lemonade.</p>
<p class="indent-para">When life gives <em>me</em> lemons, I pour a glass of vodka on the rocks and call it a day. But don’t get me wrong, I’m not a lush. I’m a God-fearing Christian woman who carries the Bible with her everywhere, but that’s only because my Good Book doubles as a phone book. I used all the blank pages in the back to write down the numbers I can’t remember.</p>
<p class="indent-para"><em>Forgive me Lord for being a heathen.</em></p>
<p class="indent-para">This story is about human beings, who would be perfect if they weren’t so flawed.</p>
<p class="indent-para">My friend, this is the story of me.</p>
<p class="indent-para">And, oh yeah, it’s about you, too.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// frontmatter02.vue?8e42e6f6